import React, { useEffect, useRef, useState } from 'react';
import { PlusCircleFill, Cross } from 'sushiweb/Icons';
import { green, grey, white } from 'sushiweb/tokens/color';

// eslint-disable-next-line no-global-assign, react/display-name
export default Text = ({
  field,
  inputKey,
  saveOptions,
  unSaveOptions,
  errors,
  isEditable = true,
  isMultiSelect = false,
  defaultValue = '',
  dataToSend = {},
  clearInputs = false,
}) => {
  const [textValue, setTextValue] = useState('');
  const textInputRef = useRef();

  useEffect(() => {
    if (!defaultValue) return;
    setTextValue(defaultValue);
    if (!isMultiSelect) textInputRef.current.value = defaultValue;
  }, [defaultValue]);

  useEffect(() => {
    if (clearInputs) {
      textInputRef.current.value = null;
    }
  }, [clearInputs]);

  const addMoreInput = () => {
    if (!textInputRef?.current?.value) return;
    saveOptions(inputKey, textValue);
    setTextValue(null);
    textInputRef.current.value = null;
  };

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-4'>
      <div className='tw-w-full tw-gap-4'>
        <input
          type='text'
          placeholder={field?.placeholder}
          className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px] tw-w-full
    ${
      errors?.message
        ? 'focus:tw-ring-[#BF2938] focus:tw-border-red-500'
        : 'focus:tw-ring-green-500 focus:tw-border-green-500'
    }  tw-border tw-border-solid tw-border-[#cfcfcf]`}
          autoComplete='off'
          onChange={(e) => {
            setTextValue(e.target.value);
            if (!isMultiSelect) saveOptions(inputKey, e.target.value);
          }}
          ref={textInputRef}
          readOnly={!isEditable}
        />
        {isMultiSelect ? (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <div
            className={`${
              textInputRef?.current?.value
                ? 'tw-cursor-pointer'
                : 'tw-cursor-not-allowed'
            } `}
            onClick={addMoreInput}
          >
            <PlusCircleFill
              color={`${textInputRef?.current?.value ? green.z700 : grey.z500}`}
              size={24}
            />
          </div>
        ) : null}
      </div>
      {isMultiSelect && dataToSend[inputKey]?.length ? (
        <div className='tw-w-full tw-flex tw-gap-4 '>
          {dataToSend[inputKey].map((prevInput, index) => (
            <span
              className='tw-flex tw-gap-3 tw-py-2 tw-px-3 tw-bg-green-700 tw-text-base-white tw-rounded-full  tw-h-11 tw-min-w-fit'
              key={index}
            >
              <span className='tw-text-200 tw-font-medium'>{prevInput}</span>
              <span className='tw-border tw-border-solid tw-border-white tw-rounded-full'>
                <Cross
                  color={white}
                  size={15}
                  onClick={(e) => {
                    e.preventDefault();
                    unSaveOptions(inputKey, prevInput);
                  }}
                />
              </span>
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
};
